import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

export class yoguru {
  private model: THREE.Group | null = null;
  private rotationSpeed: number = 1; // 回転速度（ラジアン/秒）

  constructor(private scene: THREE.Scene, assetsBase: string) {
    // DRACOLoaderを設定
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath("https://www.gstatic.com/draco/v1/decoders/");
    const loader = new GLTFLoader();
    loader.setDRACOLoader(dracoLoader);

    // yoguru.glbの読み込み
    const yoguruPath = `${assetsBase}/models/work-039/yoguru.glb`;
    loader.load(
      yoguruPath,
      (gltf) => {
        // モデルをシーンに追加
        this.model = gltf.scene;
        // モデルをシーンに追加
        this.scene.add(this.model);
      },
      (progress) => {
        // console.log(progress);
      },
      (error) => {
        console.error("Error loading dog model:", error);
      }
    );
  }

  // アニメーション更新メソッド（外部から呼び出し）
  public update(deltaTime: number): void {
    if (this.model) {
      // z軸を軸に回転
      this.model.rotation.y += this.rotationSpeed * deltaTime;
    }
  }
}
